import { BaseItem, RenderMetaBaseItemCore } from '../shared';
import {
  EditorItemType,
  EditorStarterItem,
} from '@/features/remotion-editor/editor/items/item-type';
import { ClipType } from '@/shared/apis/editor/clip-types';
import { DtoEmotion, DtoVendor } from '@/shared/constants';

export type AudioItemRenderMeta = {
  clipType: Extract<ClipType, 'audio'>;
  start: number;
  end: number;
  sceneId: number;
  vendorModel?: DtoVendor;
  voiceId?: string | null;
  pitch?: number | null;
  emotion?: DtoEmotion | null;
  speedFactor?: number | null;
  requestVoiceId?: string | null;
} & RenderMetaBaseItemCore;

export type AudioItem = BaseItem & {
  type: Extract<EditorItemType, 'audio'>;
  audioStartFromInSeconds: number;
  decibelAdjustment: number;
  playbackRate: number;
  audioFadeInDurationInSeconds: number;
  audioFadeOutDurationInSeconds: number;
  assetId: string;
  renderMeta?: AudioItemRenderMeta;
};

export const isAudioItem = (item?: EditorStarterItem): item is AudioItem => {
  if (!item) return false;

  return item.type === 'audio';
};
